import styled from '@emotion/styled';

export const PdfPreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #fff;
  border-radius: 20px;
  border: solid 2px #d6c9bf;
  margin: 57px 0;
  min-height: 103px;
  min-width: 413px;
`;

export const PdfPreviewContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  height: 100%;
  width: 100%;
  padding: 15px;

  div svg {
    height: 100%;
  }
`;

export const PdfPreviewInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  height: 100%;
  gap: 0.5rem;
  max-width: 150px;

  // This is to reset the styles (https://stackoverflow.com/questions/20850594/what-is-the-default-margin-value-of-p-tag)
  p {
    margin: unset;
    padding: unset;

    b {
      word-break: break-all;
    }
  }
`;
